import {ajaxCommunity, getCommunityUrl, formatData, uploadImg} from "../request";
// 1GET 2POST 3PUT 4DELETE
//
const generalUrl = '/music/generalMusic'
export default {
  // 音乐审核列表
  getMusicLibsAuditList(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/audit/list",2,generalUrl), data, {
      method,
    });
  },
  // 批量处理审核
  batchHandleMusicLibsAudit(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/audit/batchHandle",2,generalUrl), data, {
      method,
    });
  },
  // 音乐库列表
  getMusicLibsList(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/library/list",2,generalUrl), data, {
      method,
    });
  },
  // 新增音乐库
  addMusicLibs(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/library/add",2,generalUrl), data, {
      method,
    });
  },
  // 编辑音乐库
  editMusicLibs(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/library/edit",2,generalUrl), data, {
      method,
    });
  },
  // 批量删除音乐库
  batchDelMusicLibs(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/library/batchDel",2,generalUrl), data, {
      method,
    });
  },
  // 设置音乐发布区域
  setMusicLibsRegion(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/library/setRegion",2,generalUrl), data, {
      method,
    });
  },
    // 设置下架分区
  batchOfflineMusicLibsRegion(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/library/batchOfflineRegion",2,generalUrl), data, {
      method,
    });
  },
  // 设置上架分区
  batchOnlineMusicLibsRegion(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/library/batchSetRegion",2,generalUrl), data, {
      method,
    });
  },
  // 音乐发布列表
  getMusicPublishList(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/musicPublish/list",2,generalUrl), data, {
      method,
    });
  },
  // 编辑音乐发布
  editMusicPublish(data, method) {
    return ajaxCommunity("post", getCommunityUrl("/mgrMusic/musicPublish/edit",2,generalUrl), data, {
      method,
    });
  },
};



// WEBPACK FOOTER //
// ./src/js/https/musicLibs.js